// Probably doesn't really belong here, but it fits paramIconMap
import 'icons/button-jobsearch-company.svg';
import 'icons/button-jobsearch-date.svg';
import 'icons/button-jobsearch-geo.svg';
import 'icons/button-jobsearch-jobcategory.svg';
import 'icons/button-jobsearch-jobtitle.svg';
import 'icons/button-jobsearch-jobtype.svg';
import 'icons/button-jobsearch-keyword.svg';
import 'icons/button-jobsearch-time.svg';
import 'icons/button-jobsearch-workplace.svg';

export const queryTypes = [
    "companyid",
    "employment_place",
    "employment_type",
    "geoareaid",
    "jobtitleid",
    "q",
    "subid",
    "workinghours_type",
];

/**TODO: Move the error validation logic where this is used, somewhere centralized */
export const PART_TIME_MAX_HOURS = 36;

export const badgeTypes = Object.freeze({
    NEARLOCATION: 'nearlocation',
});

export const paramIconMap = {
    companyid: 'button-jobsearch-company',
    employment_place: 'button-jobsearch-workplace',
    employment_type: 'button-jobsearch-jobtype',
    geoareaid: 'button-jobsearch-geo',
    jobage: 'button-jobsearch-date',
    jobtitleid: 'button-jobsearch-jobtitle',
    q: 'button-jobsearch-keyword',
    subid: 'button-jobsearch-jobcategory',
    workinghours_type: 'button-jobsearch-time',
};
